import { render, staticRenderFns } from "./groupBuyingList.vue?vue&type=template&id=f9f0c7f6&scoped=true&"
import script from "./groupBuyingList.vue?vue&type=script&lang=js&"
export * from "./groupBuyingList.vue?vue&type=script&lang=js&"
import style0 from "./groupBuyingList.vue?vue&type=style&index=0&id=f9f0c7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f0c7f6",
  null
  
)

export default component.exports